import React, { useContext } from 'react';

import MaterialGrid from '@mui/material/Grid/Grid';

import { useHeader } from '@ezbobdev/ui-commons';
import { MainContext, SYSTEM_EVENTS, checkIsWebView, useTranslation } from '@ezbobdev/ui-framework';

import MaterialButton from '../../MaterialButton/MaterialButton';
import MaterialTypography from '../../MaterialTypography/MaterialTypography';

export const ExitPopoverContent = (props) => {
  const { iconSrc, configByName, handleExitPopoverOpen } = props;
  const { actions } = useContext(MainContext);
  const isWebView = checkIsWebView();

  const { logout } = useHeader(props, 'MaterialAppBar');

  const { t } = useTranslation();

  const handleExitClick = isWebView ? () => actions.events.emit(SYSTEM_EVENTS.CLIENT_TERMINATED) : logout;

  return (
    <>
      <MaterialGrid justifyContent="center" display="flex" item>
        <img src={iconSrc} alt={t(`${configByName}.exit.popover.iconAlt`)} />
      </MaterialGrid>

      <MaterialGrid item>
        <MaterialTypography align="center" variant="h2">
          {t(`${configByName}.exit.popover.title`)}
        </MaterialTypography>
      </MaterialGrid>

      <MaterialGrid display="flex" justifyContent="center" gap={4} marginTop={6}>
        <MaterialButton onClick={handleExitClick}>{t(`${configByName}.exit.popover.exitButton`)}</MaterialButton>
        <MaterialButton variant="outlined" onClick={handleExitPopoverOpen}>
          {t(`${configByName}.exit.popover.cancelButton`)}
        </MaterialButton>
      </MaterialGrid>
    </>
  );
};
